var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app-container",
      staticStyle: { height: "100%", "min-height": "350px" }
    },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c(
            "el-form",
            {
              attrs: {
                model: _vm.query,
                inline: true,
                size: "small",
                "label-width": "140px"
              }
            },
            [
              _c(
                "el-form-item",
                [
                  _c("el-input", {
                    staticClass: "filter-item",
                    staticStyle: { width: "180px" },
                    attrs: {
                      clearable: "",
                      placeholder: _vm.$i18n.t("common.title"),
                      oninput: "value=value.replace(/[%]/g,'')"
                    },
                    nativeOn: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.handleQuery.apply(null, arguments)
                      }
                    },
                    model: {
                      value: _vm.query.title,
                      callback: function($$v) {
                        _vm.$set(_vm.query, "title", $$v)
                      },
                      expression: "query.title"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("dataSelect", {
                    staticClass: "filter-item",
                    staticStyle: { width: "180px", "margin-left": "10px" },
                    attrs: {
                      clearable: "",
                      codeType: "article_type",
                      placeholder: _vm.$i18n.t("common.column")
                    },
                    model: {
                      value: _vm.query.articleType,
                      callback: function($$v) {
                        _vm.$set(_vm.query, "articleType", $$v)
                      },
                      expression: "query.articleType"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "filter-item",
                      staticStyle: { width: "180px", "margin-left": "10px" },
                      attrs: {
                        multiple: true,
                        placeholder: _vm.$i18n.t("common.ShowCountry")
                      },
                      model: {
                        value: _vm.query.countryCode,
                        callback: function($$v) {
                          _vm.$set(_vm.query, "countryCode", $$v)
                        },
                        expression: "query.countryCode"
                      }
                    },
                    _vm._l(_vm.countrysDicts, function(cc) {
                      return _c("el-option", {
                        key: cc.code,
                        attrs: {
                          label: cc.name + "(" + cc.code + ")",
                          value: cc.code
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "filter-item",
                      staticStyle: { width: "180px", "margin-left": "10px" },
                      attrs: {
                        p: "",
                        placeholder: _vm.$i18n.t("common.type"),
                        clearable: ""
                      },
                      model: {
                        value: _vm.query.fileType,
                        callback: function($$v) {
                          _vm.$set(_vm.query, "fileType", $$v)
                        },
                        expression: "query.fileType"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: {
                          label: _vm.$i18n.t("common.Pictureandtext"),
                          value: "image"
                        }
                      }),
                      _c("el-option", {
                        attrs: {
                          label: _vm.$i18n.t("common.video"),
                          value: "video"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "filter-item",
                      staticStyle: { width: "180px", "margin-left": "10px" },
                      attrs: {
                        placeholder: _vm.$i18n.t("common.state"),
                        clearable: ""
                      },
                      model: {
                        value: _vm.query.publishStatus,
                        callback: function($$v) {
                          _vm.$set(_vm.query, "publishStatus", $$v)
                        },
                        expression: "query.publishStatus"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: {
                          label: _vm.$i18n.t("common.Comingsoon"),
                          value: "0"
                        }
                      }),
                      _c("el-option", {
                        attrs: {
                          label: _vm.$i18n.t("common.Publishinginprogress"),
                          value: "1"
                        }
                      }),
                      _c("el-option", {
                        attrs: {
                          label: _vm.$i18n.t("common.Ended"),
                          value: "2"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "filter-item",
                      staticStyle: { width: "180px", "margin-left": "10px" },
                      attrs: {
                        placeholder: _vm.$i18n.t("common.Enableornot"),
                        clearable: ""
                      },
                      model: {
                        value: _vm.query.status,
                        callback: function($$v) {
                          _vm.$set(_vm.query, "status", $$v)
                        },
                        expression: "query.status"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: { label: _vm.$i18n.t("common.yes"), value: "1" }
                      }),
                      _c("el-option", {
                        attrs: { label: _vm.$i18n.t("common.no"), value: "0" }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "filter-item",
                      staticStyle: { "margin-left": "10px" },
                      attrs: { icon: "el-icon-search", type: "primary" },
                      on: { click: _vm.handleQuery }
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$i18n.t("common.query")) +
                          "\n                    "
                      )
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "filter-item",
                      staticStyle: { "margin-left": "10px" },
                      attrs: {
                        icon: "el-icon-search",
                        type: "primary",
                        size: "small"
                      },
                      on: { click: _vm.cleanQuery }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$i18n.t("common.Reset")) +
                          "\n                    "
                      )
                    ]
                  )
                ],
                1
              ),
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "filter-item",
                      staticStyle: { margin: "0px 0px 0px 0px" },
                      attrs: { type: "success", icon: "el-icon-edit" },
                      on: { click: _vm.handleCreate }
                    },
                    [
                      _vm._v(
                        "\n\n                    " +
                          _vm._s(_vm.$i18n.t("common.Add1")) +
                          "\n\n                    "
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading"
            }
          ],
          staticStyle: { width: "100%", "margin-top": "20px" },
          attrs: {
            height: "calc(100% - 170px)",
            data: _vm.list.list,
            border: "",
            stripe: ""
          }
        },
        [
          _c("el-table-column", {
            attrs: {
              label: _vm.$i18n.t("common.column"),
              prop: "articleType",
              align: "center",
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("dataText", {
                      attrs: { codeType: "article_type" },
                      model: {
                        value: scope.row.articleType,
                        callback: function($$v) {
                          _vm.$set(scope.row, "articleType", $$v)
                        },
                        expression: "scope.row.articleType"
                      }
                    })
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "countryCodes",
              label: _vm.$i18n.t("common.ShowCountry"),
              "show-overflow-tooltip": "",
              align: "center"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return _vm._l(scope.row.countryCodes, function(item, index) {
                    return _c("span", { key: index }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(item) +
                          "\n                        "
                      ),
                      scope.row.countryCodes.length != 1 &&
                      index != scope.row.countryCodes.length - 1
                        ? _c("span", [_vm._v("/")])
                        : _vm._e()
                    ])
                  })
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$i18n.t("common.title"),
              prop: "title",
              align: "center",
              "show-overflow-tooltip": ""
            }
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$i18n.t("common.type"),
              prop: "fileType",
              align: "center",
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    row.fileType == "image"
                      ? _c("span", [
                          _vm._v(_vm._s(_vm.$i18n.t("common.Pictureandtext")))
                        ])
                      : _vm._e(),
                    row.fileType == "video"
                      ? _c("span", [
                          _vm._v(_vm._s(_vm.$i18n.t("common.video")))
                        ])
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": true,
              prop: "imageUrl",
              label: _vm.$i18n.t("common.cover"),
              align: "center"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("listImage", { attrs: { imgUrl: scope.row.imageUrl } })
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$i18n.t("common.state"),
              prop: "publishStatus",
              align: "center",
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    row.publishStatus == 0
                      ? _c("span", { staticStyle: { color: "red" } }, [
                          _vm._v(_vm._s(_vm.$i18n.t("common.Comingsoon")))
                        ])
                      : _vm._e(),
                    row.publishStatus == 1
                      ? _c("span", { staticStyle: { color: "green" } }, [
                          _vm._v(
                            _vm._s(_vm.$i18n.t("common.Publishinginprogress"))
                          )
                        ])
                      : _vm._e(),
                    row.publishStatus == 2
                      ? _c("span", { staticStyle: { color: "gray" } }, [
                          _vm._v(_vm._s(_vm.$i18n.t("common.Ended")))
                        ])
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$i18n.t("common.starttime"),
              prop: "startTime",
              align: "center",
              "show-overflow-tooltip": "",
              formatter: _vm.formatDate
            }
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$i18n.t("common.Endtime"),
              prop: "endTime",
              align: "center",
              "show-overflow-tooltip": "",
              formatter: _vm.formatDate
            }
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$i18n.t("common.sort"),
              prop: "sort",
              align: "center",
              "show-overflow-tooltip": "",
              sortable: ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [_c("span", [_vm._v(_vm._s(row.sort))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "status",
              label: _vm.$i18n.t("common.Enableornot"),
              "show-overflow-tooltip": "",
              width: "100",
              align: "center"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("el-switch", {
                      attrs: {
                        "active-color": "#13ce66",
                        "inactive-color": "#ff4949"
                      },
                      on: {
                        change: function($event) {
                          return _vm.handleStatusChange(scope.$index, scope.row)
                        }
                      },
                      model: {
                        value: scope.row.status,
                        callback: function($$v) {
                          _vm.$set(scope.row, "status", $$v)
                        },
                        expression: "scope.row.status"
                      }
                    })
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$i18n.t("common.operation"),
              align: "center",
              width: "230"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c(
                      "el-button",
                      {
                        staticClass: "table-inner-button",
                        attrs: { type: "primary", size: "mini" },
                        on: {
                          click: function($event) {
                            return _vm.handleUpdate(row)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$i18n.t("common.edit")))]
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "table-inner-button",
                        attrs: { type: "danger", size: "mini" },
                        on: {
                          click: function($event) {
                            return _vm.handleDeleteSingle(row)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$i18n.t("common.delete")))]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "block" },
        [
          _c("el-pagination", {
            staticStyle: { "margin-top": "10px" },
            attrs: {
              background: "",
              "current-page": _vm.query.page,
              "page-size": _vm.query.size,
              layout: "total, prev, pager, next, jumper",
              total: _vm.list.total
            },
            on: { "current-change": _vm.handleCurrentChange }
          })
        ],
        1
      ),
      _vm.addVisible
        ? _c(
            "el-dialog",
            {
              attrs: {
                title: _vm.formTitle,
                visible: _vm.addVisible,
                "close-on-click-modal": false,
                width: "950px"
              },
              on: {
                "update:visible": function($event) {
                  _vm.addVisible = $event
                },
                close: function($event) {
                  return _vm.closeForm()
                }
              }
            },
            [
              _c(
                "el-form",
                {
                  ref: "dataForm",
                  staticStyle: { width: "400px", "margin-left": "50px" },
                  attrs: {
                    rules: _vm.formRules,
                    model: _vm.addArticle,
                    "label-position": "left",
                    size: "small",
                    "label-width": "150px"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$i18n.t("common.column"),
                        prop: "articleType"
                      }
                    },
                    [
                      _c("dataSelect", {
                        staticClass: "filter-item",
                        staticStyle: { width: "180px" },
                        attrs: {
                          clearable: "",
                          codeType: "article_type",
                          placeholder: _vm.$i18n.t("common.column")
                        },
                        on: { change: _vm.handleArticleTypeChange },
                        model: {
                          value: _vm.addArticle.articleType,
                          callback: function($$v) {
                            _vm.$set(_vm.addArticle, "articleType", $$v)
                          },
                          expression: "addArticle.articleType"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$i18n.t("common.ShowCountry"),
                        prop: "countryCodes"
                      }
                    },
                    [
                      _c(
                        "el-checkbox",
                        {
                          attrs: { indeterminate: _vm.isIndeterminate },
                          on: { change: _vm.handleCheckAllChange },
                          model: {
                            value: _vm.checkAll,
                            callback: function($$v) {
                              _vm.checkAll = $$v
                            },
                            expression: "checkAll"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$i18n.t("common.SelectAll")))]
                      ),
                      _c(
                        "el-checkbox-group",
                        {
                          staticStyle: { width: "600px" },
                          on: { change: _vm.handleCheckedCitiesChange },
                          model: {
                            value: _vm.addArticle.countryCodes,
                            callback: function($$v) {
                              _vm.$set(_vm.addArticle, "countryCodes", $$v)
                            },
                            expression: "addArticle.countryCodes"
                          }
                        },
                        _vm._l(_vm.countrysDicts, function(country) {
                          return _c(
                            "el-checkbox",
                            {
                              key: country.code,
                              attrs: { label: country.code }
                            },
                            [
                              _vm._v(
                                _vm._s(country.name) +
                                  "(" +
                                  _vm._s(country.code) +
                                  ")"
                              )
                            ]
                          )
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$i18n.t("common.type"),
                        prop: "fileType"
                      }
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          on: {
                            change: function($event) {
                              return _vm.fileTypeChange()
                            }
                          },
                          model: {
                            value: _vm.addArticle.fileType,
                            callback: function($$v) {
                              _vm.$set(_vm.addArticle, "fileType", $$v)
                            },
                            expression: "addArticle.fileType"
                          }
                        },
                        [
                          _c(
                            "el-radio",
                            {
                              attrs: {
                                label: "image",
                                disabled: _vm.ugcSelected
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$i18n.t("common.Pictureandtext"))
                              )
                            ]
                          ),
                          _c("el-radio", { attrs: { label: "video" } }, [
                            _vm._v(_vm._s(_vm.$i18n.t("common.video")))
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$i18n.t("common.Releasetime"),
                        prop: "startTime"
                      }
                    },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "datetimerange",
                          "range-separator": _vm.$i18n.t("common.to"),
                          "start-placeholder": _vm.$i18n.t("common.starttime"),
                          "end-placeholder": _vm.$i18n.t("common.Endtime"),
                          "picker-options": _vm.pickerOptions,
                          "default-time": ["00:00:00", "23:59:59"]
                        },
                        model: {
                          value: _vm.valuePicker,
                          callback: function($$v) {
                            _vm.valuePicker = $$v
                          },
                          expression: "valuePicker"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "600px" },
                      attrs: {
                        prop: "imageUrl",
                        label: _vm.$i18n.t("common.picture")
                      }
                    },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 10 } },
                        [
                          _c("imgUpload", {
                            ref: "imageUpload",
                            attrs: { img: _vm.imageUrl },
                            on: { event: _vm.changeUrl }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        {
                          staticStyle: { "margin-top": "150px" },
                          attrs: { span: 10 }
                        },
                        [
                          _vm.ugcSelected
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$i18n.t("common.Suggestedsize")) +
                                    "：255*453，<=200KB"
                                )
                              ])
                            : _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$i18n.t("common.Suggestedsize")) +
                                    "：466*280，<=200KB"
                                )
                              ])
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$i18n.t("common.sort"), prop: "sort" }
                    },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "100%" },
                        model: {
                          value: _vm.addArticle.sort,
                          callback: function($$v) {
                            _vm.$set(_vm.addArticle, "sort", $$v)
                          },
                          expression: "addArticle.sort"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$i18n.t("common.Enableornot"),
                        prop: "status"
                      }
                    },
                    [
                      _c("el-switch", {
                        attrs: { "active-color": "#13ce669" },
                        model: {
                          value: _vm.addArticle.status,
                          callback: function($$v) {
                            _vm.$set(_vm.addArticle, "status", $$v)
                          },
                          expression: "addArticle.status"
                        }
                      })
                    ],
                    1
                  ),
                  _vm.addArticle.fileType == "image"
                    ? _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "800px" },
                          attrs: {
                            label: _vm.$i18n.t(
                              "common.Multilingualconfiguration"
                            )
                          }
                        },
                        [
                          _c(
                            "el-menu",
                            {
                              staticClass: "el-menu-demo",
                              attrs: {
                                "default-active": _vm.contentIndex,
                                mode: "horizontal"
                              },
                              on: { select: _vm.handleContentSelect }
                            },
                            _vm._l(_vm.langs, function(item, index) {
                              return _c(
                                "el-menu-item",
                                { key: item.code, attrs: { index: item.code } },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(item.name) +
                                      "\n                        "
                                  )
                                ]
                              )
                            }),
                            1
                          ),
                          _c(
                            "div",
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$i18n.t("common.title")) + "："
                                )
                              ]),
                              _c("el-input", {
                                staticStyle: {
                                  "margin-top": "20px",
                                  width: "450px"
                                },
                                attrs: {
                                  "show-word-limit": "",
                                  maxlength: "200",
                                  placeholder: _vm.$i18n.t(
                                    "common.Pleaseenteratitle"
                                  ),
                                  label: _vm.$i18n.t("common.title")
                                },
                                model: {
                                  value: _vm.title,
                                  callback: function($$v) {
                                    _vm.title = $$v
                                  },
                                  expression: "title"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticStyle: { "margin-top": "20px" } },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$i18n.t("common.content")) + "："
                                )
                              ]),
                              _c("wangEditer", {
                                ref: "wangEditer",
                                staticStyle: { "margin-top": "10px" },
                                attrs: { conten: _vm.contentValue }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.addArticle.fileType == "video"
                    ? _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "800px" },
                          attrs: { label: _vm.$i18n.t("common.video") }
                        },
                        [
                          _c(
                            "el-menu",
                            {
                              staticClass: "el-menu-demo",
                              attrs: {
                                "default-active": _vm.contentIndex,
                                mode: "horizontal"
                              },
                              on: { select: _vm.handleVideoSelect }
                            },
                            _vm._l(_vm.langs, function(item, index) {
                              return _c(
                                "el-menu-item",
                                { key: item.code, attrs: { index: item.code } },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(item.name) +
                                      "\n                        "
                                  )
                                ]
                              )
                            }),
                            1
                          ),
                          _c(
                            "div",
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$i18n.t("common.title")) + "："
                                )
                              ]),
                              _c("el-input", {
                                staticStyle: {
                                  "margin-top": "20px",
                                  width: "450px"
                                },
                                attrs: {
                                  "show-word-limit": "",
                                  maxlength: "200",
                                  placeholder: _vm.$i18n.t(
                                    "common.Pleaseenteratitle"
                                  ),
                                  label: _vm.$i18n.t("common.title")
                                },
                                model: {
                                  value: _vm.title,
                                  callback: function($$v) {
                                    _vm.title = $$v
                                  },
                                  expression: "title"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticStyle: { "margin-top": "20px" } },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$i18n.t("common.UploadVideo")) +
                                    "："
                                )
                              ]),
                              _c("videoUpload", {
                                ref: "videoUpload",
                                attrs: { video: _vm.videoUrl },
                                on: { event: _vm.changeVideoUrl }
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$i18n.t("common.VideoScript")) +
                                    "："
                                )
                              ]),
                              _c("el-input", {
                                staticStyle: {
                                  "margin-top": "20px",
                                  width: "450px"
                                },
                                attrs: {
                                  type: "textarea",
                                  placeholder: _vm.$i18n.t(
                                    "common.PleaseEnterOrPasteTheVideoScript"
                                  ),
                                  label: _vm.$i18n.t("common.VideoScript")
                                },
                                model: {
                                  value: _vm.videoOutsideUrl,
                                  callback: function($$v) {
                                    _vm.videoOutsideUrl = $$v
                                  },
                                  expression: "videoOutsideUrl"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          return _vm.closeForm()
                        }
                      }
                    },
                    [_vm._v("  " + _vm._s(_vm.$i18n.t("common.cancel")) + " ")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.handleSubmit()
                        }
                      }
                    },
                    [_vm._v("  " + _vm._s(_vm.$i18n.t("common.confirm")) + " ")]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }